import { render, staticRenderFns } from "./Cutdown.vue?vue&type=template&id=7d822f57&scoped=true"
import script from "./Cutdown.vue?vue&type=script&lang=js"
export * from "./Cutdown.vue?vue&type=script&lang=js"
import style0 from "./Cutdown.vue?vue&type=style&index=0&id=7d822f57&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d822f57",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/centurygame/web-vip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d822f57')) {
      api.createRecord('7d822f57', component.options)
    } else {
      api.reload('7d822f57', component.options)
    }
    module.hot.accept("./Cutdown.vue?vue&type=template&id=7d822f57&scoped=true", function () {
      api.rerender('7d822f57', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/Goods/Cutdown.vue"
export default component.exports